import { useState, useEffect } from "react";
import { usePermissions } from "context";

const usePermission = (requiredPermission, requiredModule) => {
  const [hasPermission, setHasPermission] = useState(false);
  const { permissions } = usePermissions(); // Usar el contexto

  useEffect(() => {
    // Usar los permisos del contexto si están disponibles, sino del sessionStorage
    let storedPermissions = permissions;
    
    // Si no hay permisos en el contexto, intentar cargar del sessionStorage
    if (!Array.isArray(storedPermissions) || storedPermissions.length === 0) {
      try {
        storedPermissions = JSON.parse(sessionStorage.getItem("permissions")) || [];
      } catch (error) {
        console.error("Error parsing permissions:", error);
        storedPermissions = [];
      }
    }

    // Leer el rol del usuario desde el sessionStorage
    let userRole;
    try {
      userRole = JSON.parse(sessionStorage.getItem("role")) || { name: "" };
    } catch (error) {
      console.error("Error parsing role:", error);
      userRole = { name: "" };
    }

    // Si el rol es "superadmin", le damos acceso a todo
    if (userRole.name === "Superadmin") {
      setHasPermission(true);
    } else {
      // Verificar si el usuario tiene el permiso requerido
      setHasPermission(
        Array.isArray(storedPermissions) && storedPermissions.some(
          (permission) =>
            permission.name === requiredPermission && permission.module === requiredModule
        )
      );
    }
  }, [requiredPermission, requiredModule, permissions]); // Agregar permissions como dependencia

  return hasPermission;
};

export default usePermission;
